"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRouteId = exports.ROUTE_FALLBACK = void 0;
const lodash_1 = require("lodash");
const productionRoutes_1 = require("./productionRoutes");
const __1 = require("../..");
const pageset_1 = require("./pageset");
const cookie_1 = __importDefault(require("cookie"));
const logging_1 = __importDefault(require("../logging"));
/**
 * Return the first route that matches the path.
 * @param {URL} parsedURL
 * @param cookies
 * @param routes
 */
function getRoute(parsedURL, cookies, routes = productionRoutes_1.PRODUCTION_ROUTES) {
    const { pathname, searchParams } = parsedURL;
    const matchedRoutes = lodash_1.cloneDeep(routes).filter((route) => new RegExp(route.pattern).test(pathname));
    const route = matchedRoutes.length >= 1 ? matchedRoutes[0] : null;
    // Add additional route context.
    if (route) {
        const extractedContext = extractRouteContext(pathname, searchParams, route, cookies);
        route.context = Object.assign({}, route.context, removeNull(extractedContext));
    }
    return route;
}
/**
 * Extract context from the URL using the route pattern's named capture groups and any URL params, falling back to cookie value or _direct if most prior not existing.
 */
function extractRouteContext(pathname, searchParams, route, cookies) {
    var _a, _b, _c, _d;
    const matches = new RegExp(route.pattern).exec(pathname);
    let language_code = (_c = (searchParams.get('lc') || ((_b = (_a = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _a === void 0 ? void 0 : _a.locale) === null || _b === void 0 ? void 0 : _b.split('-')[0]))) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    // This covers the transformation that was existing in the growth backend when the language code was used from server context
    if (language_code === 'jp') {
        language_code = 'ja';
    }
    const route_id = exports.getRouteId(searchParams, matches, cookies, route);
    const pageSetLayer = (_d = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _d === void 0 ? void 0 : _d.pageset_layer;
    const mappedContextType = pageset_1.getContextTypeByPageSetLayer(pageSetLayer);
    return {
        language_code,
        route_id,
        context_type: mappedContextType,
    };
}
/**
 * Return an object with null or undefined keys removed.
 * @param {Object} obj
 */
function removeNull(obj) {
    const newObj = {};
    Object.keys(obj)
        .filter((key) => obj[key] !== undefined && obj[key] !== null)
        .forEach((key) => (newObj[key] = obj[key]));
    return newObj;
}
exports.ROUTE_FALLBACK = '_direct';
/**
 * Function returns expected route based on request in priority order:
 * 1. Any route id specified in the route takes first precedence
 * 2. Any route id specified in a cookie takes second precedence
 * 4. Fallback to _direct route id if all else fails
 */
const getRouteId = (searchParams, routeMatches, cookies, route) => {
    var _a, _b, _c;
    let routeId = searchParams.get('route') ||
        ((_a = routeMatches === null || routeMatches === void 0 ? void 0 : routeMatches.groups) === null || _a === void 0 ? void 0 : _a.route_id) ||
        ((_b = route === null || route === void 0 ? void 0 : route.context) === null || _b === void 0 ? void 0 : _b.route_id);
    if (routeId) {
        if ((route === null || route === void 0 ? void 0 : route.context) && 'route_id_prefix' in route.context) {
            const { route_id_prefix: prefix, } = route.context;
            routeId = prefix + routeId;
        }
        logging_1.default(`Setting route_id based on route context: ${routeId}`);
        return routeId;
    }
    const parsedCookies = cookie_1.default.parse(cookies || '');
    const cookieRouteId = parsedCookies[__1.ROUTE_COOKIE_KEY];
    if (cookieRouteId) {
        logging_1.default(`Setting route_id based on user cookie: ${cookieRouteId}`);
        return cookieRouteId;
    }
    const fallback = ((_c = route === null || route === void 0 ? void 0 : route.context) === null || _c === void 0 ? void 0 : _c.fallback_route_id) || exports.ROUTE_FALLBACK;
    logging_1.default(`No route id overrides found, falling back to ${fallback}`);
    return fallback;
};
exports.getRouteId = getRouteId;
exports.default = getRoute;
//# sourceMappingURL=route.js.map